
import { useProfileData } from "@/hooks/useProfileData";
import Navbar from "@/components/layout/Navbar";
import ProfileHeader from "./ProfileHeader";
import ProfileCard from "./ProfileCard";
import ProfileForm from "./ProfileForm";
import LoadingState from "./LoadingState";
import NotFoundState from "./NotFoundState";
import { useAuth } from "@/contexts/AuthContext";

const ProfilePage = () => {
  const { user } = useAuth();
  const { 
    userProfile, 
    formData, 
    setFormData, 
    isEditing, 
    setIsEditing, 
    isLoading, 
    isSaving, 
    handleInputChange, 
    handleSaveProfile,
    handleSignOut
  } = useProfileData();

  // Loading state
  if (isLoading) {
    return (
      <>
        <Navbar />
        <div className="container max-w-4xl mx-auto pt-32 pb-16 px-4">
          <LoadingState />
        </div>
      </>
    );
  }

  // Not authenticated or profile not found
  if (!userProfile) {
    return (
      <>
        <Navbar />
        <div className="container max-w-4xl mx-auto pt-32 pb-16 px-4">
          <NotFoundState />
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container max-w-4xl mx-auto pt-32 pb-16 px-4">
        <ProfileHeader 
          title="My Profile" 
          subtitle="Manage your account information and preferences" 
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* User Card */}
          <ProfileCard 
            userProfile={userProfile} 
            email={user?.email || ""}
            onEditClick={() => setIsEditing(true)} 
          />

          {/* Profile Form */}
          <ProfileForm 
            email={user?.email} 
            formData={formData}
            isEditing={isEditing}
            isSaving={isSaving}
            onInputChange={handleInputChange}
            onSave={handleSaveProfile}
            onCancel={() => setIsEditing(false)}
            onEdit={() => setIsEditing(true)}
            onSignOut={handleSignOut}
          />
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
